@if (hasChanged) {
  <p class="not-saved-block">Изменения не сохранены</p>
}

@if (!IsSelected && !ItemData) {
  <div class="content-wrap empty" [innerHTML]=" 'Нет текста'"></div>
}
@if (!IsSelected && ItemData) {
  <div class="content-wrap inner-text disable-copy html-view" [innerHTML]="ItemData|safe"></div>
}

@if (IsSelected) {
  <div (click)="$event.stopPropagation()">
    <angular-tiptap-editor
      style="cursor: text"
      [content]="ItemData"
      [config]="editorConfig"
      (contentChange)="onContentChange($event)"
      />
    <br>
      <div class="buttons">
        <div class="button" (click)="changeText()">Сохранить текст</div>
        <div class="button" (click)="cancelChangeText()">Вернуть назад</div>
      </div>
    </div>
  }




